import React, {useState,useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthProvider';


const JewelleryCard = ({ itemKey, picture, 
    description, datePurchased, storageLocation}) => {

    const navigate = useNavigate();
    
    const handleClick = () => {
        navigate("/jewellery/details", {state:{key: `${itemKey}`}});
    }
  
    return ( 
        // TODO: Put all the CSS in App.css
        <div 
            className="grid-item" 
            onClick={handleClick}
            >
            <div align="center">
            <img
            src={picture}
            
            width="250" 
            height="250"
            /></div>
            <p align="center">{description}</p>
            <p align="center">{storageLocation}</p>
        </div>
);
};

export default JewelleryCard;
